export class AppUpdateAction {
    public static readonly type = '[App] update';
}
